import log, { authTokenExists } from "@fxid/shared";

import { fetchProfileData } from "./fetchProfileData";
import { FxIdWebFeaturesProfileGetResponse } from "./gen";

/**
 * Асинхронно получает данные профиля пользователя. Возвращает undefined если токена нет
 */
export const fetchProfileDataIfAvailable = async (
	gameSystemName: string | undefined,
	forceRefetch = false
): Promise<FxIdWebFeaturesProfileGetResponse | undefined> => {
	if (!authTokenExists()) {
		log.debug("No auth token for profile to get");
		return Promise.resolve(undefined);
	}

	return fetchProfileData(gameSystemName, forceRefetch);
};
